/// <reference path="../include.ts" />

namespace project_guide {

	import View = alm.view.View;
	import Hash = alm.util.Hash;
	import WindowWatcher = alm.browser.WindowWatcher;
	import Lang = project_common.Lang;
	import Region = project_common.Region;
	import Area = project_common.Area;
	import Spot = project_common.Spot;
	import Zone = project_common.Zone;
	import Species = project_common.Species;
	import Dom = alm.util.Dom;
	import DataParser = project_common.DataParser;
	import CommonLocalizable = project_common.CommonLocalizable;
	import Application = project_common.Application;
	import DomUtil = project_common.DomUtil;

	export class ListView extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super(jQuery('#list-view'));
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.baseScrollContainer = jQuery('#base-scroll-container');
			this.baseScrollPosition1 = 0;
			this.baseScrollPosition2 = 0;
			this.isBaseScrollEnabled = true;

			// reset
			this.clearContext();

			return view;
		}

		protected implReady():void {
			WindowWatcher.start();
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Command();
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Command();
		}





		public clearContext():void {
			const view = this.getView();

			const itemContainer = view.find('.region-container');
			itemContainer.empty();

			this.regionViewByUrn = {};
			this.areaViewByUrn = {};
			this.zoneViewByUrn = {};
			this.speciesViewByUrn = {};
		}

		public setContext():void {
			this.clearContext();
			const lang = Application.getPresetContext().lang;
			const spot = Application.getSpotData();
			const view = this.getView();

			// region
			{
				const itemContainer = view.find('.region-container');
				const itemDataList = spot.regions;
				const itemCount = itemDataList.length;
				for (let i = 0; i < itemCount; ++i) {
					const itemData = itemDataList[i];
					const itemView = this.createRegionView(spot, itemData, lang);
					itemContainer.append(itemView);
				}
			}
		}

		private createRegionView(spot:Spot, region:Region, lang:Lang):JQuery {
			const view = jQuery(Dom.instantiate('list-item-region-template'));
			view.attr('data-urn', region.urn);

			// register view
			this.regionViewByUrn[region.urn] = view;

			// area
			{
				const itemContainer = view.find('.area-container');
				const itemDataList = region.areas;
				const itemCount = itemDataList.length;
				for (let i = 0; i < itemCount; ++i) {
					const itemData = itemDataList[i];
					const itemView = this.createAreaView(spot, region, itemData, lang);
					itemContainer.append(itemView);
				}
			}

			return view;
		}

		private createAreaView(spot:Spot, region:Region, area:Area, lang:Lang):JQuery {
			const view = jQuery(Dom.instantiate('list-item-area-template'));
			view.attr('data-urn', area.urn);

			// register view
			this.areaViewByUrn[area.urn] = view;

			// zone
			{
				const itemContainer = view.find('.zone-container');
				const itemDataList = area.zones;
				const itemCount = itemDataList.length;
				for (let i = 0; i < itemCount; ++i) {
					const itemData = itemDataList[i];
					const itemView = this.createZoneView(spot, region, area, itemData, lang);
					itemContainer.append(itemView);
				}
			}

			return view;
		}

		private createZoneView(spot:Spot, region:Region, area:Area, zone:Zone, lang:Lang):JQuery {
			const view = jQuery(Dom.instantiate('list-item-zone-template'));
			view.attr('data-urn', zone.urn);

			// flag
			if (zone.meta.linneLensScreen) {
				view.addClass('has-camera');

				// click action
				const icon = view.find('.block-right .camera-icon');
				icon.addClass('clickable');
				icon.on('click', (event:JQuery.ClickEvent):void => {
					window.alert(DataParser.localize(CommonLocalizable.cameraDescription, lang));
					event.originalEvent.preventDefault();
				});
			}

			// register view
			this.zoneViewByUrn[zone.urn] = view;

			// header
			{
				const header = view.find('.zone-header-sticky');
				BindingUtil.setZoneHeaderText(header, region, area, zone, lang);
			}

			// species
			{
				const itemContainer = view.find('.species-container');
				const itemDataList = zone.species;
				const itemCount = itemDataList.length;
				for (let i = 0; i < itemCount; ++i) {
					const itemData = itemDataList[i];
					const itemView = this.createSpeciesView(spot, region, area, zone, itemData, lang);
					itemContainer.append(itemView);
				}
			}

			return view;
		}

		private createSpeciesView(spot:Spot, region:Region, area:Area, zone:Zone, species:Species, lang:Lang):JQuery {
			const view = jQuery(Dom.instantiate('list-item-species-template'));
			view.attr('data-urn', species.urn);

			// register view
			this.speciesViewByUrn[species.urn] = view;

			// setup click action
			if (DataParser.localize(species.commentary, lang)) {
				view.addClass('has-detail');
			}

			// click action
			view.addClass('clickable');
			view.on('click', (event:JQuery.ClickEvent):void => {
				//window.location.href = '#/' + region.urn + '/' + area.urn + '/' + zone.urn + '/' + species.urn;
				this.dispatchEvent(new ListViewEvent(ListViewEvent.requireGotoScene, this, region, area, zone, species));
			});

			// image
			{
				const image = view.find('.image');
				const defaultImageUrl = '../static/img/species-default-icon.png';
				DomUtil.loadImageToBackground(image, [species.iconImageUrl, defaultImageUrl]);
			}

			// name
			{
				const content = view.find('.name');
				BindingUtil.setSpeciesNameTexts(content, species, lang);
			}

			// commentary
			{
				const commentary = DataParser.localize(species.commentary, lang);
				const content = view.find('.commentary');
				if (commentary) {
					const title = commentary.title;
					const body = commentary.body;
					if (title || body) {
						content.css('display', 'block');

						const field = content.find('.title');
						if (title) {
							DomUtil.setHtml(field, title);
						} else {
							DomUtil.setHtml(field, body);
						}

					} else {
						content.css('display', 'none');
					}

				} else {
					content.css('display', 'none');
				}
			}

			return view;
		}





		public scrollToTop(useTransition:boolean = true):void {
			this.scrollTo(0, useTransition);
		}

		public scrollToRegion(region:Region, useTransition:boolean = true):void {
			const view = this.regionViewByUrn[region.urn];
			this.scrollTo(view.offset().top, useTransition);
		}

		public scrollToArea(area:Area, useTransition:boolean = true):void {
			const view = this.areaViewByUrn[area.urn];
			this.scrollTo(view.offset().top, useTransition);
		}

		public scrollToZone(zone:Zone, useTransition:boolean = true):void {
			const view = this.zoneViewByUrn[zone.urn];
			this.scrollTo(view.offset().top, useTransition);
		}

		public scrollToSpecies(species:Species, useTransition:boolean = true):void {
			const view = this.speciesViewByUrn[species.urn];
			this.scrollTo(view.offset().top, useTransition);
		}

		private scrollTo(position:number, useTransition:boolean = true):void {
			this.baseScrollPosition2 = position;
			if (this.isBaseScrollEnabled) {
				Dom.scrollTo(position, useTransition);
			}
		}





		public saveScrollPosition():void {
			this.isBaseScrollEnabled = false;
			this.baseScrollPosition1 = this.baseScrollPosition2 = WindowWatcher.getScrollTop();
			this.baseScrollContainer.css({ position: 'fixed', top: -this.baseScrollPosition1 });
			Dom.scrollTo(0, false);
		}

		public loadScrollPosition():void {
			this.isBaseScrollEnabled = true;
			this.baseScrollContainer.css({ position: 'relative', top: 0 });
			Dom.scrollTo(this.baseScrollPosition2, this.baseScrollPosition1 != this.baseScrollPosition2);
		}





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		public static getInstance():ListView { return this.instance || (this.instance = new ListView()) };
		private static instance:ListView = null;

		private regionViewByUrn:Hash<JQuery>;
		private zoneViewByUrn:Hash<JQuery>;
		private areaViewByUrn:Hash<JQuery>;
		private speciesViewByUrn:Hash<JQuery>;

		private baseScrollContainer:JQuery;
		private baseScrollPosition1:number;
		private baseScrollPosition2:number;
		private isBaseScrollEnabled:boolean;
	}
}
